import styled, { css } from 'styled-components'
import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import {
  getCustomTextStyle,
  TextBody,
  getStyles,
  textStylesConfig,
  Heading2Serif,
} from '@styles/vars/textStyles.style'
import { mq } from '@styles/vars/media-queries.style'
import { GridMain } from '@components/Grid/index.style'
import { AnimateSlideInContent } from '@components/animation/AnimateSlideIn/index.style'
import { roundedCorners } from '@utils'



export const HubspotFormMain = styled.section`

  ${GridMain} {
    align-items: end;
  }
  select {
    background-color: ${props => props.background};
  }
`

export const HubspotFormWrapper = styled.div`
  position: relative;
  p {
    font-size: inherit;
  }
`

export const FormHaeding = styled.div`
  ${Heading2Serif} {
    ${getCustomTextStyle(
      textStylesConfig.heading1Serif,
      textStylesConfig.heading1Serif
    )}
  }
  max-width: 90rem;
`

export const InfoText = styled.div`
  p {
    color: ${colors.mist};
    font-size: 14px;
  }
`

export const ItemSectionTitle = styled.h2`
  ${clamp('font-size', 18, 25)}
`